App.controller('ProfileProtegesCtrl', ['$scope', '$sce', '$state', '$http', function ($scope, $sce, $state, $http) {
    $scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));

    if ($scope.userData.type !== 'MAIN_USER') {
    	$state.go('root.dashboard');
    }
}]);